import React, { ReactElement, ReactNode, useMemo } from 'react';
import Step from '@/components/stepper/Step';
import StepperContext, { StepperContextType } from '@/components/stepper/context/StepperContext';
import { Element } from '@/components/stepper/Stepper.styles';

export type StepsType = string[];

export interface StepperProps {
  children?: ReactNode | ReactElement;
  active: number;
  steps: StepsType;
}

const Stepper = ({ active, steps, children, ...props }: StepperProps) => {
  const context = useMemo<StepperContextType>(() => ({ active, steps }), [active, steps]);

  return (
    <StepperContext.Provider value={context}>
      <Element>
        <Step />
      </Element>
    </StepperContext.Provider>
  );
};

export default Stepper;
